import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/location/indirapuram-ghaziabad")({
  beforeLoad: () => {
    throw redirect({ to: "/locations/indirapuram-ghaziabad", replace: true, statusCode: 301 });
  },
});
